{
  "name": "slow-burn",
  "doc": "A long decay with the faintest zoom-out: the trails last for seconds and smoulder. The hue drifts far along the wheel in that time. The governor is what keeps it honest.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 0.994,
  "zoomexp": 1.0,
  "rot": 0.0015,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0.003,
  "warpScale": 3,
  "warpSpeed": 0.15,
  "decay": 0.972,
  "invert": 0,
  "hueShift": 0.007,
  "darkenCenter": 0.1,
  "wave": "CIRCLE",
  "waveColor": 2,
  "shapes": 1,
  "energy": [
    0.0,
    0.45
  ]
}